export class Attachment {

    constructor(public filename: string, public base64: string, public mimetype?: string) {
        this.filename = filename;
        this.base64 = base64;
    }

}

/**
 * convert the File[] to an Attachment[]
 * @param files
 */
export function convertFilesToAttachments(files: File[]) {
    return new Promise<Attachment[] | []>((resolve, reject) => {
        const attachments: Attachment[] = [];
        let counter = 0;
        if (files && files.length > 0) {
            files.map((file: File) => {
                convertFileToAttachment(file).then((attachment: Attachment) => {
                    attachments.push(attachment);
                    counter++;

                    // last file so ready
                    counter === files.length && resolve(attachments);
                }).catch(() => counter++);
            });
        } else {
            resolve(attachments);
        }
    });
}

/**
 * convert File to an Attachment
 * @param file
 */
export function convertFileToAttachment(file: File) {
    return new Promise<Attachment | null>((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(new Attachment(file.name, reader.result as string, file.type));
        reader.onerror = () => reject(null);
    });
}
